import React from "react";

import Image from "next/image";

import LeadCaptureImage from "public/images/enerflo-vsr-24-7-lead-capture-icon.png";
import AnalyticsIcon from "public/images/enerflo-vsr-analytics-reporting-icon.png";
import InstantQuotesIcon from "public/images/enerflo-vsr-instant-solar-quotes-icon.png";
import SeamlessIntegrationIcon from "public/images/enerflo-vsr-seamless-integration-icon.png";
import TrackReferralSourcesIcon from "public/images/enerflo-vsr-track-referral-sources-icon.png";
import UnlimitedConfigurationsIcon from "public/images/enerflo-vsr-unlimited-configurations-icon.png";
import WhiteLabelIcon from "public/images/enerflo-vsr-white-labeled-for-you-icon.png";

import Heading from "../../../heading";
import HeroSection from "../../../hero-section";
import styles from "./index.module.css";

const items = [
  {
    title: "24/7 Lead Capture & Qualification",
    description: "Engage homeowners anytime, day or night, with an automated online experience.",
    image: LeadCaptureImage,
  },
  {
    title: "Instant Solar Quotes",
    description: "Provide accurate, real-time quote estimates based on homeowner inputs.",
    image: InstantQuotesIcon,
  },
  {
    title: "Seamless Integration",
    description: "Qualified prospects flow directly into Enerflo Sales Core for quick follow-up and conversion.",
    image: SeamlessIntegrationIcon,
  },
  {
    title: "Unlimited Configurations",
    description: "Deploy multiple versions of VSR to fit your needs from different websites, campaigns, or kiosks.",
    image: UnlimitedConfigurationsIcon,
  },
  {
    title: "White-Labeled For You",
    description: "Configurable branding and messaging to match your company’s look and feel.",
    image: WhiteLabelIcon,
  },
  {
    title: "Built-In Analytics & Reporting",
    description: "Track lead volume, engagement, and conversion data in one place.",
    image: AnalyticsIcon,
  },
  {
    title: "Track Prospect Referral Sources",
    description: "Capture referral codes or UTM parameters to measure paid and organic campaign success.",
    image: TrackReferralSourcesIcon,
  },
];

const title = "Key Features of Enerflo VSR";

const KeyFeatures = () => (
  <div className="bg-navy text-white">
    <HeroSection title={title} className="flex-col">
      <HeroSection.Content className="w-full md:w-3/4 md:text-center">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description className="text-gray-300">
          Enerflo VSR gives solar companies inside sales in a box — powerful automation that empowers your sales team,
          scales your reach, and improves efficiency across the board.
        </HeroSection.Description>
      </HeroSection.Content>

      <div className={styles.itemsGrid}>
        {items.map((item, index) => (
          <div key={index} className={styles.item}>
            <div>
              <figure className="h-20 w-20 lg:h-28 lg:w-28 relative mx-auto">
                <Image src={item.image} alt={`Enerflo Virtual Sales Rep (VSR): ${item.title} Icon.`} layout="fill" />
              </figure>
              <Heading tag="h4" size="h5" className="text-primary mt-2">
                {item.title}
              </Heading>
            </div>
            <p className="mt-2 text-gray-300">{item.description}</p>
          </div>
        ))}
      </div>
    </HeroSection>
  </div>
);

export default KeyFeatures;
